<da-checkout *ngIf="(activeStep$ | async) === 0" [showLogin]="showLogin" (nextStep)="goToStep($event)"> </da-checkout>
<section class="background-color-nearwhite steps-wrapper" *ngIf="activeStep > 0">
    <da-steps [activeStep]="activeStep" *ngIf="activeStep > 0"></da-steps>
</section>

<div *ngIf="activeStep > 0">
    <da-booking-person *ngIf="activeStep === 1" (nextStep)="goToStep($event)" (loggedIn)="showSteper($event)"></da-booking-person>
    <da-booking-participants *ngIf="activeStep === 2" (nextStep)="goToStep($event)"></da-booking-participants>
    <da-booking-summary *ngIf="activeStep === 3" (nextStep)="goToStep($event)"></da-booking-summary>
    <da-booking-confirmation *ngIf="activeStep === 4" (nextStep)="goToStep($event)"></da-booking-confirmation>
</div>
